import * as React from 'react'
import styled from 'styled-components'
import I18n from 'core/i18n'
import { BREAKPOINT_DESKTOP_XL, COLORS } from 'static/constants'
import SvgIcon from 'components/atoms/SvgIcon'

export enum ReservationModalType {
  StartDate,
  New,
  Confirm,
}
interface IProps {
  type: ReservationModalType
  closeHandle: () => void
}

export const ReservationFullScreenModalHeaderContent: React.VFC<IProps> = ({
  type,
  closeHandle,
}) => {
  return (
    <ModalHeaderContent>
      <SvgIcon
        name={type === ReservationModalType.Confirm ? 'close' : 'arrow_back'}
        className="icon"
        role="button"
        onClick={closeHandle}
      />
      <div className="title">
        {type === ReservationModalType.StartDate && 'Select Dates'}
        {type === ReservationModalType.New && 'Confirm and Pay'}
        {type === ReservationModalType.Confirm && I18n.t('post.tour_confirmation')}
      </div>
    </ModalHeaderContent>
  )
}

const ModalHeaderContent = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  margin: 0 auto;
  .icon {
    position: absolute;
    cursor: pointer;
    height: 3.2rem;
    width: 3.2rem;
    padding: 0.4rem;
    left: -4rem;
    transition: color 0.2s;
    &:hover {
      color: ${COLORS.primary};
    }
    @media (max-width: ${BREAKPOINT_DESKTOP_XL}px) {
      left: -3.2rem;
      padding: 0.6rem;
    }
  }
  .title {
    font-size: 2rem;
    @media (max-width: ${BREAKPOINT_DESKTOP_XL}px) {
      font-size: 1.6rem;
    }
  }
`
